module.exports = __webpack_public_path__ + "img/find-candidates.11ed11a.svg";